// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMediaCamCamOff_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s80IconSvg = html `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M38.5266 41.7L40.2141 40.0125L40.2151 40.0135L69.2254 11.0032L69.2244 11.0022L69.2251 11.0015L72.0535 13.8299L66.8835 18.9999H73V64.9999H20.8835L12.6566 73.2269L9.82916 70.3995L38.5276 41.701L38.5266 41.7ZM49.4749 36.4085L62.8835 22.9999H69V60.9999H24.8835L34.4085 51.4749C36.047 52.4439 37.9585 53 40 53C46.0751 53 51 48.0751 51 42C51 39.9585 50.4439 38.047 49.4749 36.4085ZM37.3873 48.4961L46.4961 39.3873C46.8211 40.1946 47 41.0764 47 42C47 45.866 43.866 49 40 49C39.0764 49 38.1946 48.8211 37.3873 48.4961Z" class="svg-bg"/>
  <path d="M33.0137 41.5581C33.2326 38.0441 36.0441 35.2326 39.5581 35.0137L43.1223 31.4494C42.1325 31.157 41.0846 31 40 31C33.9249 31 29 35.9249 29 42C29 43.0846 29.157 44.1325 29.4494 45.1223L33.0137 41.5581Z" class="svg-bg"/>
  <path d="M13.5719 60.9999H11V22.9999H51.5719L55.5719 18.9999H7V64.9999H9.57189L13.5719 60.9999ZM52 11H27L25 15H54L52 11Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMediaCamCamOff is a generated icon component.
 */
let IconMediaCamCamOff = IconMediaCamCamOff_1 = class IconMediaCamCamOff extends IconBaseElement {
    render() {
        return html `${IconMediaCamCamOff_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMediaCamCamOff.icons = new Map([
    ['s8', _s80IconSvg],
    ['s12', _s80IconSvg],
    ['s16', _s80IconSvg],
    ['s24', _s80IconSvg],
    ['s32', _s80IconSvg],
    ['s40', _s80IconSvg],
    ['s48', _s80IconSvg],
    ['s64', _s80IconSvg],
    ['s72', _s80IconSvg],
    ['s80', _s80IconSvg],
]);
IconMediaCamCamOff = IconMediaCamCamOff_1 = __decorate([
    customElement('zui-icon-media-cam-cam-off')
], IconMediaCamCamOff);
export { IconMediaCamCamOff };
